import { LoadCicdProjectJobsQuery } from "~/operations";

export type CicdProjectJobs = NonNullable<
  LoadCicdProjectJobsQuery["cicdProjectJobs"]
>;
export type CicdProject = NonNullable<CicdProjectJobs["project"]>;

export type CiCdHeader = {
  id: string;
  label: string;
  options?: {
    align?: "inherit" | "left" | "center" | "right" | "justify";
    colSpan?: number;
  };
};

export enum JobsTypes {
  CircleCI = "circleci.com",
  Kubernetes = "k8s.mondoo.com",
  Github = "actions.github.com",
  Gitlab = "gitlab.com",
  Jenkins = "jenkins.io",
  Azure = "devops.azure.com",
  GithubActions = "actions.github.com",
}

export type Project = CicdProjectJobs["project"];
type JobsConnection = NonNullable<CicdProjectJobs["jobs"]>;
export type JobsEdge = NonNullable<JobsConnection["edges"]>[0];
export type Job = JobsEdge["node"];
type AzureDevopsJob = Extract<Job, { __typename: "AzureDevopsJob" }>;
type CircleCIJob = Extract<Job, { __typename: "CircleCIJob" }>;
type GithubJob = Extract<Job, { __typename: "GithubJob" }>;
type GitlabJob = Extract<Job, { __typename: "GitlabJob" }>;
type JenkinsJob = Extract<Job, { __typename: "JenkinsJob" }>;
type KubernetesJob = Extract<Job, { __typename: "KubernetesJob" }>;

export interface CombinedPossibleJobs
  extends AzureDevopsJob,
    GitlabJob,
    GithubJob,
    CircleCIJob,
    JenkinsJob,
    KubernetesJob {
  __typename: never;
}
